<template>
	<div id='shenlist'>
		<div style="padding-top: 1.5rem;position: relative;left: 0s;">
			<a-row class='main-mybody' style="height:19.5rem">
				<div class='mydivs'>
					<div style="text-align: center;    padding: 0.9rem 0;" v-if=' tableData == null'>暫無審核記錄</div>
					<div v-for='(item,ind) in tableData'>
						<!-- :style="{borderBottom:ind!==tableData.length-1?'1px solid #d9d9d9':'' }" -->
						<div class="c" style="border-bottom:1px solid #d9d9d9;">
							<div style="max-width: 60%;">
								<div style="display: inline-block;max-width: 6rem;min-width: 3.5rem;vertical-align: top;">
									<span style='font-weight: 700;'>{{item.adminname}} </span>　
								</div>
								<div style="display: inline-block;vertical-align: top;margin-right: .2rem;"> : </div>
								<div style="display: inline-block;max-width: 78%;" v-if='item.audittext'>
									{{ item.audittext }}
								</div>
							</div>
							<div style="display: flex;justify-content: space-between;">
								<div style="margin-right: .8rem;">{{ item.realname }}</div>
								<div>{{ item.createTime }}</div>
							</div>
						</div>
					</div>
					<div class="c" style="justify-content: center;">
						<a-icon type="plus" style="font-size: 25px;color: #c1c1c1;cursor: pointer;" @click="addClick()" v-if="addFlag"></a-icon>
						<div style="display: flex;width: 100%;align-items: center;" v-else>
							<div style="flex-shrink: 0;margin-right: 15px;font-weight: 700;">審核記錄</div>
							<a-input v-model="sh_input"></a-input>
							<div style="flex-shrink: 0;margin: 0 50px;color: #0c8b97;cursor: pointer;" @click="addsave(1)">保存</div>
							<div style="flex-shrink: 0;margin-right: 40px;cursor: pointer;" @click="addsave(2)">取消</div>
						</div>
					</div>
				</div>
			</a-row>
		</div>
	</div>
</template>

<script>
	import https from '@/plugins/http.js';
	import apiUrl from '@/assets/api.js';
	import App from '@/assets/app.js';
	export default {
		props: ['record', 'form', 'forms'],
		data() {
			return {
				tableData: null,
				addFlag:true,
				sh_input:'',
			}
		},
		mounted() {
			this.getdata()
		},
		methods: {
			addClick(){
				this.addFlag = false
			},
			addsave(val){
				if (val == 1) {
					this.addData(this.sh_input)
					// var arr = {
					// 	"admin": "aaa ipo编辑管理员",
					// 	"remark": this.sh_input,
					// 	"position": "ipo编辑管理员",
					// 	"realname": "aaa",
					// 	"status": 2,
					// 	"auditDate": "29/05/2023 16:57"
					// }
					// this.tableData.push(arr)
					
				}else{
					this.addFlag = true
					this.sh_input = ''
				}
			},
			addData(val) {
				if (!val) {
					this.$message.warning('請填寫審核記錄')
					return
				}
				
				let _this = this;
				let json = {
					token: _this.$store.state.token,
				}
				https.fetchPost(apiUrl.addAuditTrail, {
					pdfcode: this.record.pdfcode,
					admintype: _this.forms.admintype,
					audittext: val,
				}, json).then((data) => {
					if (Object.is(data.qmiscode, 1000)) {
						this.$message.success(data.qmismsg)
						this.getdata()
						this.sh_input = ''
						this.addFlag = true

					} else {
						this.$message.warning(data.qmismsg)
					}
				}).catch(err => {
					console.log(err);
				});
			},
			getdata() {
				let _this = this;
				let json = {
					token: _this.$store.state.token,
				}
				https.fetchPost(apiUrl.getAuditTrail, {
					// token: json.token,
					id: this.record.pdfcode
				}, json).then((data) => {
					if (Object.is(data.qmiscode, 1000)) {
						this.tableData = data.auditLog
					} else {
						this.$message.warning(data.qmismsg)
					}
				}).catch(err => {
					console.log(err);
				});
			},

		}
	}
</script>

<style lang='scss' scoped>
	#shenlist {
		.mydivs {
			/* padding: 1rem; */
			/* margin-left: 3%; */
			/* margin: 0 auto; */
			
			/* width: 96%; */
			padding: 0 1rem;
			background-color: #f5f5f5;
			margin-bottom: 1rem;

			.c {
				/* border-bottom: 1px solid #d9d9d9; */
				padding: .9rem 0;
				font-size: 0.835rem;
				/* margin-bottom: .8rem; */
				align-items: flex-start;
				display: flex;
				justify-content: space-between;
			}

			/* .t {
				margin: .5rem 0;
				border-top: 1px solid #d9d9d9;
			}
			 */
		}
		
		/* .mydivs .c:last-child {
			border-bottom: 1px solid #d9d9d9;
		} */
		/* .mydivs:last-child {
			border-bottom: 1px solid #d9d9d9;
		} */
	}
</style>
